<template>
  <div class="dashboard-wrapper">
    <employee-probation-reminder
      v-if="showProbationReminder"
      :probation="probations"
      @load="loadProbations"
    />

    <v-container
      fluid
      class="pa-6"
    >
      <v-row justify="center">
        <div 
          class="d-flex flex-wrap"
          style="gap: 8px;"
        >
          <v-card
            v-for="item in filteredMenu"
            :key="item.title"
            class="pa-4 dashboard-card rounded-xl ma-2"
            :style="{ backgroundColor: item.bgColor }"
            @click="go(item.route)"
          >
            <v-avatar 
              size="44" 
              :color="item.iconColor + ' lighten-4'"
            >
              <v-icon :color="item.iconColor">
                {{ item.icon }}
              </v-icon>
            </v-avatar>

            <div class="text-subtitle-1 font-weight-bold black--text mb-1">
              {{ item.title }}
            </div>
            <div class="text-caption grey--text text--darken-3">
              {{ getStatusLabel(item.title) }}
            </div>
          </v-card>
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      EmployeeProbationReminder: () => import('@/components/hris/employee/ProbationReminder'),
    },
    data () {
      return {
        menu: [
          { title: 'Leave', icon: 'mdi-calendar-account', bgColor: '#E0F7FA', iconColor: 'cyan', route: '/my-leave' },
          { title: 'Payslip', icon: 'mdi-checkbook', bgColor: '#E0F7FA', iconColor: 'cyan', route: '/my-payslip' },
          { title: 'EA Form', icon: 'mdi-file-document-outline', bgColor: '#E0F7FA', iconColor: 'cyan', route: '/my-ea' },
          { title: 'Letter', icon: 'mdi-email-open', bgColor: '#E0F7FA', iconColor: 'cyan', route: '/e-letter' },
          { title: 'Attendance', icon: 'mdi-flag', bgColor: '#E0F7FA', iconColor: 'cyan', route: '/my-attendance' },
          { title: 'Claim', icon: 'mdi-hand-coin', bgColor: '#E0F7FA', iconColor: 'cyan', route: '/my-claim' },
          { title: 'Organization Chart', icon: 'mdi-lan', bgColor: '#E0F7FA', iconColor: 'cyan', route: '/orgchart' },
        ],
        probations: [],
        showProbationReminder: false,
      }
    },
    computed: {
      ...mapState({ employee: 'currentEmployee' }),
      filteredMenu () {
        return this.menu.filter(item => {
          if (item.title === 'Claim') {
            return this.employee.current_position.position.has_claim && this.employee.claim_types.length > 0
          }
          return true
        })
      },
    },
    watch: {
      employee: {
        immediate: true,
        handler (value) {
          if (value) {
            if (this.$hasPermissionTo(['view probations'])) {
              this.loadProbations()
            }
          }
        },
      },
    },
    methods: {
      go (route) { this.$router.push(route) },
      getStatusLabel (title) {
        const labels = {
          'Leave': 'View and apply leave',
          'Payslip': 'Generate payslip',
          'EA Form': 'View and download EA forms',
          'Letter': 'View and download letters',
          'Attendance': 'Generate attendance report',
          'Claim': 'Manage claims',
          'Organization Chart': 'View team structure',
        }
        return labels[title] || 'View Details'
      },
      loadProbations () {
        this.$api.employeeProbations().list()
          .then(res => {
            var maxEndDate = this.$moment().add(1, 'M').format('YYYY-MM-DD')
            this.probations = res.data.filter(i => {
              return i.end_date <= maxEndDate 
            })
            this.probations = _.orderBy(this.probations, ['start_date'], ['desc'])

            // Only show once per login session
            const key = `probation-reminder-shown`

            if (this.probations.length > 0 && !sessionStorage.getItem(key)) {
              this.showProbationReminder = true
              sessionStorage.setItem(key, 'true')
            }
          })
      },
    },
  }
</script>

<style scoped>
.dashboard-wrapper { background-color: #f8faff; min-height: 70vh; }

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.1) !important;
}

.dashboard-card {
  transition: all 0.3s ease;
  min-height: 130px; 
  flex: 0 0 220px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

/* Ensure the title text is clear against pastel backgrounds */
.text-subtitle-1 {
  line-height: 1.2;
  letter-spacing: 0.01em !important;
}

.rounded-xl { border-radius: 20px !important; }
.rounded-lg { border-radius: 12px !important; }

.text-none { text-transform: none !important; }

/* Mobile-specific adjustments (Screens smaller than 600px) */
@media (max-width: 600px) {
  .dashboard-card {
    min-height: 80px; /* Slimmer cards for mobile */
    padding: 12px !important;
  }

@media (max-width: 480px) {
  .dashboard-card {
    flex: 1 1 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
  
  .text-h5 {
    font-size: 1.25rem !important; /* Smaller "Home" title */
    margin-bottom: 16px !important;
  }

  /* Reduce spacing between cards on mobile */
  .v-col {
    padding: 8px !important;
  }
}
</style>
